import React from 'react';

const PrimaryButton = ({className, ...props}) => {
    return (
        <button className={`${className} bg-green-900 text-center text-white font-medium rounded-xl p-2`} {...props}>
            {props.children}
        </button>
    );
};

export default PrimaryButton;